export const getSelect = (dataSelect) =>
  dataSelect.map((data) => {
    return {label: data, value: data};
  });

export const isPositiveNumber = (value) => value >= 0;

export const isNotDefaultSelect = (value) => value !== 'default';

export const isEmpty = (value) => value == '';

export const currencyFormat = (num) => {
  return num.toFixed(0).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ') + ' XPF';
};
